module.exports = __webpack_public_path__ + "static/img/hala24.f57d4f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala24.jpg
// module id = 9d5Z
// module chunks = 1